<template>
    <v-container  id = "homesearch" >
      <h1>Fiche entreprise</h1>
       <img class="logo m-2"  src="../../assets/background_requeteur.png" />

        <AdvancedSearch v-if="chk_advanced_search" v-on:closeSearchModal="chk_advanced_search=false" ></AdvancedSearch>
      <SearchForm v-on:search="doSearch" v-on:openSearchModal="chk_advanced_search=true" v-bind:searchString="what"  v-bind:inSearch="false" class="title_input"/>
       <v-btn icon>
          <v-icon @click="logout()">mdi-logout-variant</v-icon>
        </v-btn>
      <div style="width: 100%;text-align: justify" id="homehelp">
         <v-expansion-panels>
           <v-expansion-panel>
             <v-expansion-panel-header>
               Aide en ligne
             </v-expansion-panel-header>
             <v-expansion-panel-content>
               <p>
                  La fiche entreprise est un moteur de recherche des entreprises françaises.
                </p>
                <p>Entrez ci-dessus le nom de l'entreprise, plus éventuellement d'autres mots comme son activité, sa ville sous sa rue pour obtenir la liste des entreprises correspondant aux critères de recherche, par exemple : pharmacie gambetta nice</p>
               <p>Vous pouvez également entrer le siret ou le siren d'une enterprise. Dans ce cas attendez le chargement complet, la fiche de l'entreprise sera automatiquement affichée</p>
               <p>Pour chaque entreprise, visualisez toutes les données disponibles en un coup d'oeil</p>
               <p>Cliquez sur les pastilles pour voir des informations détaillées.</p>
               <a href="../../static/docs/manuel.pdf" target="_blank">Manuel utilisateur</a>
               <br>
               <a href="mailto:nathalie.guillemain@generali.com?subject=Question fiche entreprise">Contact : Nathalie Guillemain</a>
             </v-expansion-panel-content>
           </v-expansion-panel>
  </v-expansion-panels>


      </div>
    </v-container>
</template>

<script>
import SearchForm from '@/components/layout/SearchForm';
import Mgr from "@/services/SsoService";
import AdvancedSearch from "@/components/freeSearch/AdvancedSearch.vue";


export default {
  name: "home",
  data() {
    return {
      searchString: "",
      what:"",
      active:true,
      chk_advanced_search: false,
    }
  },
  components: {
    SearchForm,
    AdvancedSearch,
  },
  methods: {
    searchSiret(what, active) {
      // get data from store
      this.$store.dispatch('findSiretFor', {what, active})

    },
     logout() {
      var user = new Mgr();
      user.signOut();
    },
    doSearch(searchParams, active) {
      if (searchParams != null) {
        this.what = searchParams.join(' ');
      } else {
        this.what = ""
      }
      this.searchSiret(this.what, active)
    },
  }
}
</script>

<style scoped>

</style>